import clsx from 'clsx'
import {
    type ReactNode,
    useEffect,
    useState,
} from 'react'

interface Props {
    repeats: number
    interval?: number
    className?: string
    children: ReactNode | ReactNode[]
}

// Мигание содержимым.
export function Blinker(props: Props) {

    const {
        repeats = 3,
        interval = 1000,
        className,
        children,
    } = props

    // Моргание.
    useEffect(() => {
        let blinks: number = 0
        const intervalId = setInterval(() => {
            blinks++
            setIsEvenTick(blinks % 2 === 0)
            if (blinks > repeats * 2) {
                clearInterval(intervalId)
            }
        }, interval)
        return () => clearInterval(intervalId)
    }, [])

    // Чет или нечет (см blinks в useEffect).
    const [
        isEvenTick,
        setIsEvenTick,
    ] = useState<boolean>(false)

    return (
        <div className={clsx(className, isEvenTick ? 'opacity-0' : '')}>
            {children}
        </div>
    )
}
